export const COLUMN_DISPLAY_NAME = 'Column';
export const COLUMN_DEFAULT_TITLE = 'New Column';
export const COLUMN_DEFAULT_HEIGHT_IN_GRID_UNIT = 15;
